/**
 * Escolha da cor do logo (slot 1..8 da paleta de series).
 *
 * E um `radiogroup` de botoes, nao um `<select>`: a pessoa escolhe olhando a
 * amostra. Mas cor nunca viaja sozinha (RNF16): cada amostra tem o nome da cor
 * no `aria-label`, a escolhida ganha um check branco por cima e o nome aparece
 * por escrito abaixo do grupo.
 */

import { useId } from 'react';
import { Icon } from '../../../components/ui';
import type { LogoTone } from '../../../types';
import { TONES, TONE_CLASS, TONE_NAME } from '../vocabulario';

export function SeletorDeTom({ value, onChange }: { readonly value: LogoTone; readonly onChange: (tone: LogoTone) => void }): JSX.Element {
  const labelId = useId();
  return (
    <div className="flex flex-col gap-1.5">
      <span id={labelId} className="text-sm font-medium text-ink">
        Tom de cor
      </span>
      <div role="radiogroup" aria-labelledby={labelId} className="flex flex-wrap gap-2">
        {TONES.map((tone) => {
          const ativo = tone === value;
          return (
            <button
              key={tone}
              type="button"
              role="radio"
              aria-checked={ativo}
              aria-label={`${TONE_NAME[tone]} (tom ${tone})`}
              title={TONE_NAME[tone]}
              onClick={() => onChange(tone)}
              className={`grid h-11 w-11 place-items-center rounded-xl border-2 transition-colors ${ativo ? 'border-ink' : 'border-transparent hover:border-edge'}`}
            >
              <span aria-hidden="true" className={`grid h-7 w-7 place-items-center rounded-lg text-white shadow-soft ${TONE_CLASS[tone]}`}>
                {ativo ? <Icon name="check" size="xs" /> : null}
              </span>
            </button>
          );
        })}
      </div>
      <p className="text-xs text-ink-subtle">
        Selecionado: <span className="font-medium text-ink">{TONE_NAME[value]}</span> (tom {value}). Usado nas iniciais quando não há imagem de logo.
      </p>
    </div>
  );
}
